import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import ReactSelect from 'react-select'
import subsidiariesApi from 'services/api/subsidiaries'

const EditHotelTagsDialog = ({ onClose }) => {
  const [isLoadingTags, setIsLoadingTags] = useState(true)
  const [isLoadingDefinitions, setIsLoadingDefinitions] = useState(true)

  const [isErred, setIsErred] = useState(false)

  const [tagDefinitions, setTagDefinitions] = useState([])
  const [tags, setTags] = useState([])

  useEffect(() => {
    subsidiariesApi.hotelTags.definitions
      .get()
      .then(definitions => {
        setIsLoadingDefinitions(false)
        setTagDefinitions(definitions)
      })
      .catch(() => {
        setIsLoadingDefinitions(false)
        setIsErred(true)
      })
  }, [])

  useEffect(() => {
    subsidiariesApi.hotelTags
      .get()
      .then(tags => {
        setIsLoadingTags(false)
        setTags(tags)
      })
      .catch(() => {
        setIsLoadingTags(false)
        setIsErred(true)
      })
  }, [])

  function handleSave() {
    subsidiariesApi.hotelTags
      .update({ tags })
      .then(() => {
        onClose()
      })
      .catch(() => {
        setIsErred(true)
      })
  }

  return (
    <ConfirmationDialog
      title={'Edit Hotel Tags'}
      theme={'blacklist'}
      positiveMessage="Save"
      negativeMessage="Cancel"
      onClose={onClose}
      onReject={onClose}
      allowOverflow={true}
      maxWidth={700}
      onConfirm={handleSave}
    >
      <div style={{ paddingTop: 20, width: 600 }}>
        {(isLoadingDefinitions || isLoadingTags) && <LoadingIndicator />}
        {!isLoadingDefinitions && !isLoadingTags && !isErred && (
          <ReactSelect
            isMulti
            value={tags.map(t => ({ label: t.name, value: t.id }))}
            options={tagDefinitions.map(t => ({ label: t.name, value: t.id }))}
            styles={{
              control: base => ({
                ...base,
                paddingTop: 4,
                paddingBottom: 4
              }),
              multiValue: base => ({
                ...base,
                margin: 4,
                backgroundColor: '#F2F8FF',
                boxShadow: '0px 0px 0px 1px #CCDFEB'
              }),
              multiValueLabel: base => ({
                ...base,
                color: '#2B6CB0',
                fontWeight: 500,
                fontSize: 13
              })
            }}
            onChange={selectedOptions =>
              setTags(selectedOptions.map(o => ({ id: o.value, name: o.label })))
            }
          />
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default EditHotelTagsDialog
